import { render } from "./CustomProgressSpinner.vue?vue&type=template&id=c7fdedee"
import script from "./CustomProgressSpinner.vue?vue&type=script&lang=js"
export * from "./CustomProgressSpinner.vue?vue&type=script&lang=js"

import "./CustomProgressSpinner.vue?vue&type=style&index=0&id=c7fdedee&lang=css"

import exportComponent from "C:\\Users\\6217025534\\Desktop\\vsts-agent-win-x64-2\\_work\\60\\s\\WEPTW_Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__